/** Compare class titles without their schedule designator; never rewrite the saved title. */
export function classNameWithoutDesignator(name: string, code = ''): string {
  const title = name.trim()
  const escaped = code.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  // Bare numbers can be quantities. Only remove them when they are the recorded class code,
  // and retain obvious measurements even if that number happens to equal the code.
  if (
    /^(?:\d+(?:\.\d+)?)\s*(?:%|jars?\b|bottles?\b|blocks?\b|frames?\b|candles?\b|oz\b|lb\b|pounds?\b|kg\b|grams?\b)/i.test(
      title
    )
  )
    return title
  const recorded =
    escaped && new RegExp(`^(?:class\\s+)?${escaped}(?:\\s*[-–—:.)]\\s*|\\s+)(?=\\S)`, 'i')
  if (recorded && recorded.test(title)) return title.replace(recorded, '')
  return title
    .replace(/^(?:class\s+)?(?:[a-z]+\d+[a-z]?|\d+[a-z])(?:\s*[-–—:.)]\s*|\s+)(?=\S)/i, '')
    .replace(/^(?:class\s+\d+\s*[-–—:.)]?\s+|\d+\s*[-–—:.)]\s+)(?=\S)/i, '')
}
export function classNameKey(name: string, code = ''): string {
  return classNameWithoutDesignator(name, code)
    .normalize('NFKC')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase('en-US')
}
